/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('navbarComponent', () => ({
    // Existing state properties
    navopen: false,
    desktop: window.innerWidth > 991,
    hoveredtab: 'closed',

    // Scroll tracking state
    tickerVisible: false,
    scrollTimeout: null,

    // Initialization: set up scroll and resize event listeners
    init() {
      window.addEventListener('resize', () => {
        this.desktop = window.innerWidth > 991;
      });
    }
  }));
});